// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mask-loading {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  top: 0;\n  background-color: hsla(0, 0%, 100%, 0.5);\n  z-index: 10;\n}\n.mask-loading-inner {\n  position: absolute;\n  left: calc(50% - 16px);\n  top: calc(50% - 16px);\n}\n", ""]);
// Exports
module.exports = exports;
